import React from 'react';
import PropTypes from 'prop-types';
import './styles/tabs.css';

/**
 * A component for displaying tabs
 * @param {Array} tabs - Array of tab objects {key, label, icon}
 * @param {string} activeTab - Currently active tab key
 * @param {Function} onChange - Callback for tab change
 */
export default function Tabs({ tabs, activeTab, onChange }) {
  return (
    <div className="tabs-container">
      {tabs.map(tab => (
        <button
          key={tab.key}
          className={`tab-button ${activeTab === tab.key ? 'tab-active' : ''}`}
          onClick={() => onChange(tab.key)}
        >
          {tab.icon && <span className="tab-icon">{tab.icon}</span>}
          {tab.label}
        </button>
      ))}
    </div>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};